var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9098 28.7841L51.209 11H47.5836L34.2993 26.4417L23.6891 11H11.4516L27.4962 34.3506L11.4516 53H15.0772L29.1058 36.693L40.3109 53H52.5484L35.9089 28.7841H35.9098ZM30.944 34.5563L29.3183 32.2311L16.3836 13.7293H21.9523L32.3908 28.6609L34.0165 30.9861L47.5853 50.3948H42.0165L30.944 34.5572V34.5563Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogoWhite);
export default __webpack_public_path__ + "static/media/x-logo-white.bc0f9d12251fe324e0ecb4a9757b0234.svg";
export { ForwardRef as ReactComponent };